/**
 * @module BuildConstants
 */
import {defineStore} from 'pinia'
import {ref, watch} from 'vue'
import Utility from '../vue/Utility'
import * as BuildConstants from 'BuildConstants'
import Vars from "../vue/Vars";

export const useChooserStore = defineStore('ChooserStore', () => {
    const designsAreLoading = ref(false)
    const designsRowOffset = ref(0)
    const designs = ref([])
    const designIds = ref([])
    const designsCountTotal = ref(0)
    const designsRowCount = ref(12)
    const resultsUrl = ref('')
    const selectedProductLine = ref(14)
    const selectedSizes = ref(['sm', 'md', 'lg', 'xl'])
    const selectedSortOrder = ref('marketing-picks')
    const selectedAgeRange = ref('default')

    async function retrieveItemsFromServer() {
        designsAreLoading.value = true;

        try {
            let r = await axios
                .get(BuildConstants.SERVER_AJAX_URL + '/chooser/get-filtered-data', {
                    params: {
                        'sort': selectedSortOrder.value,
                        'row_offset': designsRowOffset.value,
                        'row_count': designsRowCount.value,
                        'product_line': selectedProductLine.value,
                        'sizes': selectedSizes.value,
                        'age_range': selectedAgeRange.value
                    }
                })

            let requestedUrl = axios.getUri({url: r.config.url, params: r.config.params})

            let url = new URL(requestedUrl)

            let obj = new URLSearchParams(url.search)

            resultsUrl.value = BuildConstants.SERVER_AJAX_URL + '/chooser/load?' + obj.toString()

            let len = r.data.designIds.length

            if (designsRowOffset.value > 0 && len > 0) {
                for (const [key, value] of Object.entries(r.data.designs)) {
                    let design = {}

                    design[key] = value;

                    addDesign(design)
                }

                for (let i = 0; i < len; i++) {
                    addDesignId(r.data.designIds[i])
                }
            } else {
                designs.value = r.data.designs;
                designIds.value = r.data.designIds;
            }

            setDesignsRowOffset();
            designsCountTotal.value = r.data.designsCountTotal;
            designsAreLoading.value = false;

        } catch (error) {
            Utility.catchError(error)
        }
    }

    function addDesign(design) {
        designs.value = Object.assign(designs.value, design)
    }

    function addDesignId(designId) {
        designIds.value.push(designId)
    }

    function setDesignsRowOffset() {
        designsRowOffset.value += designsRowCount.value
    }

    function resetDesignsRowOffset() {
        designsRowOffset.value = 0
    }

    async function resetSelections() {
        await this.$reset()
    }

    watch(selectedProductLine, (newSelectedProductLine, oldSelectedProductLine) => {
        if (selectedProductLine.value === Vars.PRODUCT_LINE_IU2.id || selectedProductLine.value === Vars.PRODUCT_LINE_OU2.id) {
            selectedAgeRange.value = Vars.AGE_RANGE_UNDER_TWO
        } else if (selectedProductLine.value === Vars.PRODUCT_LINE_IO2.id) {
            selectedAgeRange.value = Vars.AGE_RANGE_TWO_TO_FIVE
        }

        if (oldSelectedProductLine !== Vars.PRODUCT_LINE_OO2.id && newSelectedProductLine === Vars.PRODUCT_LINE_OO2.id) {
            selectedAgeRange.value = Vars.AGE_RANGE_DEFAULT
        }
    })

    return {
        designs,
        designIds,
        designsAreLoading,
        designsRowOffset,
        designsCountTotal,
        selectedProductLine,
        selectedSortOrder,
        selectedAgeRange,
        retrieveItemsFromServer,
        resetDesignsRowOffset,
        resetSelections
    }
}, {
    persist: true
})
